// extracted by mini-css-extract-plugin
export default {"container":"points_container__tQXJ3","noMobile":"points_noMobile__SXq7o","points":"points_points__Unc+2","icon":"points_icon__XPA-Z","mobile":"points_mobile__LOrC-"};